import { Smartphone, Rocket } from "lucide-react";
import { Reveal, Overline } from "./primitives";

export const ComingSoon = () => {
  return (
    <section
      id="coming-soon"
      data-testid="coming-soon-section"
      className="relative overflow-hidden bg-[#0e3f70] py-24 text-white sm:py-32"
    >
      <div className="absolute inset-0 pm-grid-blue opacity-50" />
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#5aa72f]/25 blur-3xl" />
      <div className="absolute -bottom-28 -left-24 h-72 w-72 rounded-full bg-[#1a6fc4]/40 blur-3xl" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <div className="flex justify-center">
            <Overline dark>PipeMitra Is Coming Soon</Overline>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-6 max-w-3xl font-heading text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            Smarter Pipeline Planning Is On Its Way.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/75">
            We&rsquo;re building PipeMitra to make agricultural pipeline planning
            simpler, more scientific and accessible for farmers, pipe &amp; pump
            dealers, and pipeline technicians.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-9 inline-flex items-center gap-2.5 rounded-full border border-[#a6d47a]/40 bg-[#5aa72f]/20 px-5 py-2 font-mono text-xs uppercase tracking-[0.22em] text-[#d3ecb6]">
            <Rocket className="h-4 w-4" />
            Launching Soon
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-col items-center gap-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/50">
              Coming soon on Android &amp; iOS
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <span
                data-testid="coming-soon-android"
                className="inline-flex cursor-default items-center gap-2.5 rounded-2xl border border-white/15 bg-white/[0.06] px-5 py-3 text-sm font-semibold text-white/80 backdrop-blur-sm"
              >
                <Smartphone className="h-5 w-5 text-[#a6d47a]" />
                Android
              </span>
              <span
                data-testid="coming-soon-ios"
                className="inline-flex cursor-default items-center gap-2.5 rounded-2xl border border-white/15 bg-white/[0.06] px-5 py-3 text-sm font-semibold text-white/80 backdrop-blur-sm"
              >
                <Smartphone className="h-5 w-5 text-[#a6d47a]" />
                iOS
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
